import * as React from "react";

const Cross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer18"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <path id="path93" d="m1.587 1.587 3.175 3.175" opacity="1"></path>
      <path id="path94" d="m1.587 4.762 3.175-3.175" opacity="1"></path>
    </g>
  </svg>
);

export default Cross;
